import { OptionalSupporterList } from './supporter'
import { Node, NodeList } from './node'
// tslint:disable:no-empty-interface

type Optional<A> = A | undefined | null

export type CollectionType = 'curated'

export type CollectionMetadataFilters = {
  type: string
  id: number
}

export interface CollectionBase {
  collection_type: Optional<CollectionType>
  asset_url: Optional<string>
  tag: Optional<string>
  nodeId: Optional<string>
  subtitle: Optional<string>
  start_date_time: Optional<string>
  end_date_time: Optional<string>
  meta_collections_page_description: Optional<string>
  meta_collections_page_title: Optional<string>
  metadata_filters: Optional<ReadonlyArray<CollectionMetadataFilters>>
  id: number
  short_title: string | null
  title: string
  description: string
  description_plain: string
  aggregated_node_ids: ReadonlyArray<number>
  aggregated_category_slugs: ReadonlyArray<string>
  slug: string
  slug_uri: string
  seo_description: string
  original_entity?: {
    type: CollectionEntityType
    slug_uri: string
    id: number
    slug: string
  }
}

export type CollectionEntityType =
  | 'person'
  | 'team'
  | 'collection'
  | 'article'
  | 'ranking'
  | 'result'
  | 'series'
  | 'video'
  | 'event'
  | 'supporter'
  | 'STREAM'
  | null

export type Collection = CollectionBase & CollectionJoin

interface CollectionJoin {
  supporters: OptionalSupporterList
  node_associations: Optional<NodeList>
}

export enum NonApiNodeTypes {
  grappling = 'grappling',
  experienceGrappling = 'experience-grappling'
}

export enum ApiNodeTypes {
  result = 'result',
  collection = 'collection',
  event = 'event',
  video = 'video',
  article = 'article',
  ranking = 'ranking'
}
